import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './assets/lang/en.json'
import en_1 from './assets/lang/en_1.json'
import en_127 from './assets/lang/en_127.json'
import ja from './assets/lang/ja.json'
import pt from './assets/lang/pt.json'
import es from './assets/lang/es.json'
import VueSession from 'vue-session'

Vue.use(VueSession, {
  persist: true
})

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages: {en, en_1, en_127, ja, pt, es},
  fallbackLocale: 'en',
  silentTranslationWarn: true
})

Vue.prototype.$t = function (key, locale, values) {
  let result = this.$i18n.t(key, locale, values)
  let keysplit = ['_']
  
  if ((result === '' || result.indexOf('.') > -1) && result === key) {
    let textArr = key.split(".")
    let text = textArr[1]
    if(text) {
      keysplit.map((item) => {
        let position = text.indexOf(item)
        if (position > -1) {
          text = text.split(text.substring(position, position + 1)).join(' ')
        }
      })
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
  }

  if(locale){
    Object.keys(locale).map((key) => {
      result = result.replace('{' + key + '}', locale[key])
    })
  }
  return result
}

export default i18n



// WEBPACK FOOTER //
// ./src/lang.js